import Vue from 'vue'
import VueRouter from 'vue-router'
import access from './access'
import Overview from '@/pages/Overview'
import Login from '@/pages/Login'
import Logout from '@/pages/Logout'
import AccessDenied from '@/pages/403'
import PageNotFound from '@/pages/404'
import Contact from './modules/contact'
import Domain from './modules/domain'
import Host from './modules/host'
import EppLog from './modules/epp-log'
import RequestLog from './modules/request-log'
import Registrar from './modules/registrar'
import Request from './modules/request'
import RGP from './modules/rgp'
import TLD from './modules/tld'
import Transfer from './modules/transfer'
import User from './modules/user'
import Transaction from './modules/transaction'
import Frontend from './modules/frontend'
import Events from './modules/events'
import AccountRecoveryForm from '@/pages/AccountRecovery'

Vue.use(VueRouter);

let defaultRoutes = {
  'overview': {
    path: '/',
    name: 'overview',
    component: Overview,
    meta: {
      access: true,
      main_menu: {
        label: "Home",
        icon: "home",
        weight: -10
      }
    }
  },
  'default': { path: '*', redirect: { name: '404' }, meta: { access: true } },
  '403': { path: '/403', name: '403', component: AccessDenied, meta: { access: true, title: "403 Access Denied" } },
  '404': { path: '/404', name: '404', component: PageNotFound, meta: { access: true, title: "404 Page Not Found" } },
  'login': {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      access: access.anonymous,
      title: "Log in",
      main_menu: {
        label: "Log in",
        icon: "key",
        weight: 1
      }
    }
  },
  'logout': {
    path: '/logout',
    name: 'logout',
    component: Logout,
    meta: {
      main_menu: {
        label: "Log out",
        icon: "lock",
        weight: 10
      }
    }
  },
  'recover': {
    path: '/recover',
    name: 'recover',
    component: AccountRecoveryForm,
    meta: {
      access: access.anonymous,
      title: "Account recovery",
    }
  },
  'admin': {
    path: '/admin',
    name: 'admin',
    redirect: { name: 'contact.collection' },
    meta: {
      main_menu: {
        label: "Administration",
        icon: "wrench",
        weight: 1
      }
    }
  },
};

let routes = Object.assign(
  defaultRoutes,
  Contact,
  Domain,
  Host,
  EppLog,
  Registrar,
  Request,
  RGP,
  TLD,
  Transfer,
  User,
  Transaction,
  Frontend,
  Events,
  RequestLog,
);

let configuration = {
  linkExactActiveClass: 'is-active',
  routes: Object.values(routes),
  mode: "history",
};

configuration.routes.forEach(route => {
  route.meta.access = route.meta.access || access.authenticated;
});

export default new VueRouter(configuration);



// WEBPACK FOOTER //
// ./src/routes/index.js